import React from 'react';
import { StudentAvatar } from '@/components/shared/StudentAvatar';

interface StudentPhotoCardProps {
  student: {
    id: string;
    name: string;
    photoFileId?: string | null;
    photoUrl: string | null;
  };
  onClick: () => void;
}

export function StudentPhotoCard({ student, onClick }: StudentPhotoCardProps) {
  return (
    <div
      onClick={onClick}
      style={cardStyle}
      role="button"
      tabIndex={0}
      aria-label={`Log behavior for ${student.name}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div style={{ marginBottom: '0.5rem' }}>
        <StudentAvatar
          name={student.name}
          photoFileId={student.photoFileId}
          photoUrl={student.photoUrl}
          size="responsive"
          border
        />
      </div>
      <div style={nameStyle}>{student.name}</div>
    </div>
  );
}

const cardStyle: React.CSSProperties = {
  cursor: 'pointer',
  textAlign: 'center',
  transition: 'transform 0.2s',
  position: 'relative',
};

const nameStyle: React.CSSProperties = {
  fontSize: '0.875rem',
  color: 'var(--text-primary)',
  fontWeight: '500',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
